var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 10,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.1217 30.8488H71.6737C72.2604 29.9202 72.6476 28.878 72.758 27.7757C73.1107 24.2528 71.2554 21.0948 68.0968 19.6947C65.1935 18.4078 61.9308 18.9339 59.5814 21.0648L53.9649 26.155C52.871 24.9586 51.2986 24.2067 49.5535 24.2067C47.8052 24.2067 46.2303 24.961 45.1362 26.1611L39.5125 21.0642C37.1593 18.9333 33.8979 18.4092 30.9959 19.6955C27.8382 21.0957 25.9825 24.2547 26.3363 27.7774C26.4469 28.8789 26.8339 29.9207 27.4205 30.8488H22.9852C20.7842 30.8488 19 32.6331 19 34.834V40.8118C19 41.9122 19.8921 42.8045 20.9927 42.8045H78.1144C79.2148 42.8045 80.1071 41.9124 80.1071 40.8118V34.834C80.1069 32.6331 78.3228 30.8488 76.1217 30.8488ZM43.5756 30.1846V30.8488H34.2015C31.7248 30.8488 29.7756 28.5399 30.3942 25.9612C30.6667 24.8256 31.4863 23.8575 32.5465 23.3675C34.0023 22.6946 35.615 22.9106 36.8377 24.0173L43.5773 30.1259C43.5769 30.1456 43.5756 30.1649 43.5756 30.1846ZM68.8038 27.2466C68.6554 29.3177 66.7845 30.849 64.7082 30.849H55.5313V30.1848C55.5313 30.1613 55.5299 30.1381 55.5297 30.1145C57.0564 28.7306 60.3684 25.7287 62.1648 24.1004C63.1857 23.1751 64.6142 22.7432 65.9347 23.137C67.8296 23.7023 68.9424 25.3137 68.8038 27.2466Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9824 46.7891V76.0142C22.9824 78.2152 24.7666 79.9994 26.9676 79.9994H45.5654V46.7891H22.9824Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5391 46.7891V79.9994H72.1368C74.3379 79.9994 76.122 78.2152 76.122 76.0142V46.7891H53.5391Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065FE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E00F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGift);
export default __webpack_public_path__ + "static/media/icon-gift.e783a002dabcb3fad47b56f195f2523a.svg";
export { ForwardRef as ReactComponent };